import { render, staticRenderFns } from "./compRuta.vue?vue&type=template&id=66d7e5ee&scoped=true&"
import script from "./compRuta.vue?vue&type=script&lang=js&"
export * from "./compRuta.vue?vue&type=script&lang=js&"
import style0 from "./compRuta.vue?vue&type=style&index=0&id=66d7e5ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7e5ee",
  null
  
)

export default component.exports